import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { syncGuestDataToServer } from "../utils/syncGuestData";
import { GoogleLogin } from "@react-oauth/google";

const LoginModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    mobile: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleGoogleLogin = async (credentialResponse) => {
  try {

    console.log("GOOGLE ID TOKEN:", credentialResponse.credential);

    const response = await axios.post(
      "https://cyberathon.com/streekatha/API/index.php/Master_controller/google_login",
      {
        token: credentialResponse.credential,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Google Login Response:", response.data);

    if (response.data.success === true) {
      toast.success(
        response.data.message || "Login successful via Google"
      );

      // Your API returns user inside data.user
      const user = response.data.data?.user;

      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
      }

      // If backend returns your application's token
      if (response.data.data?.token) {
        localStorage.setItem("token", response.data.data.token);
      }

      const userData = response.data.result;
        const userId = userData.user_id;

        // ✅ STEP 1: SYNC GUEST DATA FIRST
        await syncGuestDataToServer(userId);

        // ✅ STEP 2: Clear only OLD USER data
        localStorage.removeItem("user");
        localStorage.removeItem("user_id");

        // ✅ STEP 3: Save logged-in user
        localStorage.setItem("user", JSON.stringify(userData));
        localStorage.setItem("user_id", userId);

        console.log("Logged in user data:", userData);

        // ✅ STEP 4: Notify Navbar
        window.dispatchEvent(new Event("userLoggedIn"));

        // Close modal and reload cart
        onClose(true); // Pass true to indicate successful login

      // Redirect after successful login
      setTimeout(() => {
        navigate("/bag");
      }, 500);
    } else {
      toast.error(
        response.data.message || "Google login failed"
      );
    }
  } catch (error) {
    console.error("Google login error:", error);
    console.error("Backend response:", error.response?.data);

    toast.error(
      error.response?.data?.message ||
      "Google login failed"
    );
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.mobile.trim() || !formData.password.trim()) {
      toast.error("Please enter both fields.");
      return;
    }

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Login_Controller/user_login",
        formData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      console.log("Login Response", response.data);

      if (response.data.success === "1" && response.data.status === "true") {
        toast.success("Login successful!");

        const userData = response.data.result;
        const userId = userData.user_id;

        // ✅ STEP 1: SYNC GUEST DATA FIRST
        await syncGuestDataToServer(userId);

        // ✅ STEP 2: Clear only OLD USER data
        localStorage.removeItem("user");
        localStorage.removeItem("user_id");

        // ✅ STEP 3: Save logged-in user
        localStorage.setItem("user", JSON.stringify(userData));
        localStorage.setItem("user_id", userId);

        console.log("Logged in user data:", userData);

        // ✅ STEP 4: Notify Navbar
        window.dispatchEvent(new Event("userLoggedIn"));

        // Close modal and reload cart
        onClose(true); // Pass true to indicate successful login
      } else {
        toast.error(response.data.message || "Invalid credentials.");
      }
    } catch (err) {
      console.error("Login error:", err);
      toast.error(
        err.response?.data?.message || "Invalid mobile/email or password."
      );
    }
  };

  if (!isOpen) return null;

  return (
    <div className="login-modal-overlay" onClick={onClose}>
      <div className="login-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="login-modal-close" onClick={onClose}>
          ✕
        </button>

        <div className="login-modal-body">
          {/* <img
            src="https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/2021/7/14/1db28809-f3db-48b1-b303-d937716565661626257521634-Banner_Hamburger--2---1-.jpg"
            alt="Login Banner"
            className="login-modal-banner"
          /> */}

          <div className="login-modal-form-section">
            <div className="login-modal-header">
              Login <span className="login-modal-small">Or </span>Signup
            </div>

            <form onSubmit={handleSubmit} className="login-modal-form">
              <label>
                Mobile No. <span className="login-modal-small">Or </span> Email
              </label>
              <input
                required
                placeholder="Enter Your Mobile Number Or Email"
                name="mobile"
                id="modal-mobile"
                type="text"
                value={formData.mobile}
                onChange={handleChange}
              />

              <label>Password</label>
              <input
                required
                placeholder="Enter Your Password"
                name="password"
                id="modal-password"
                type="password"
                value={formData.password}
                onChange={handleChange}
              />

              <button type="submit" className="login-modal-continue">
                CONTINUE
              </button>

              <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    margin: "15px 0",
                    color: "#999",
                    fontSize: 13,
                  }}
                >
                  <div style={{ flex: 1, height: 1, background: "#ddd" }} />
                  <span>OR</span>
                  <div style={{ flex: 1, height: 1, background: "#ddd" }} />
                </div>
              
                          {/* Google Login */}
                <div style={{ marginBottom: 20 }}>
                  <GoogleLogin
                onSuccess={(credentialResponse) => {
                  console.log("GOOGLE ID TOKEN:", credentialResponse.credential);
                  handleGoogleLogin(credentialResponse);
                }}
                onError={() => {
                  console.log("Google Login Failed");
                }}
              />
                </div>
            </form>

            <p className="login-modal-terms">
              By continuing I agree to the{" "}
              <Link to="/PrivacyPolicy" className="login-modal-link">
                Terms of Use
              </Link>{" "}
              &amp;{" "}
              <Link to="/PrivacyPolicy" className="login-modal-link">
                Privacy Policy
              </Link>
            </p>

            <p className="login-modal-signup">
              Don't have an account?{" "}
              <Link to="/signin" className="login-modal-link-bold">
                Signup
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;